import React from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'
import { useLocation } from 'react-router-dom'

import { BadgeCounter } from 'components/designSystem/Badge/BadgeCounter'
import { EventSvg } from 'components/designSystem/svgr/EventSvg'
import {
  EventListFilter,
  eventListPath,
} from 'components/page/EventList/EventList.paths'
import { useHitsCounter } from 'components/page/EventList/hook/useHitsCounter'
import { mergeAllUrls } from 'functions/mergeAllUrls'

import { isActiveTab } from '../function/isActiveTab'
import {
  activeCss,
  Body,
  defaultCss,
  iconSizeCss,
  Link,
} from '../TabBar/TabBar.styled'

export const EventList = () => {
  const { pathname } = useLocation()
  const hitsCounter = useHitsCounter()

  return (
    <Link
      to={mergeAllUrls(eventListPath, EventListFilter.All)}
      className={cx(
        defaultCss,
        isActiveTab(pathname, eventListPath) && activeCss
      )}
      data-name="events-action"
    >
      <Body>
        <EventSvg className={cx(iconSizeCss)} />
        {hitsCounter > 0 && (
          <Badge counter={hitsCounter} data-name="hitlist-counter" />
        )}
      </Body>
    </Link>
  )
}

const Badge = styled(BadgeCounter)`
  position: absolute;
  right: 50%;
  transform: translateX(100%);
  top: 5px;
`
